/**
 * Authentication utility functions for managing user sessions
 */

/**
 * Logs out the user by clearing authentication data and redirecting to login page
 */
export const logout = () => {
  // Clear token from localStorage
  localStorage.removeItem('apiToken');
  localStorage.removeItem('apiTokenData');

  // Redirect to login page
  window.location.href = '/login';
};

/**
 * Checks if the user is authenticated
 * @returns {boolean} True if the user is authenticated, false otherwise
 */
export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('apiToken');
  const tokenDataStr = localStorage.getItem('apiTokenData');

  if (!token || !tokenDataStr) {
    return false;
  }

  try {
    const tokenData = JSON.parse(tokenDataStr);

    // Check if token is expired
    if (tokenData.expiresAt < Date.now()) {
      // Clear expired token
      localStorage.removeItem('apiToken');
      localStorage.removeItem('apiTokenData');
      return false;
    }

    return true;
  } catch {
    return false;
  }
};

/**
 * Gets the current API token
 * @returns {string|null} The API token or null if not authenticated
 */
export const getToken = (): string | null => {
  if (!isAuthenticated()) {
    return null;
  }

  return localStorage.getItem('apiToken');
};
